export default "__VITE_ASSET__f2876a5d__"